import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import NotificationCenter from '@/components/notifications/NotificationCenter';

interface ClientsHeaderProps {
  onAddClient?: () => void;
}

export const ClientsHeader: React.FC<ClientsHeaderProps> = ({ onAddClient }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'stretch', sm: 'center' },
        justifyContent: 'space-between',
        gap: 2,
        mb: 3.5,
      }}
    >
      <Typography
        component="h1"
        sx={{
          fontFamily: 'Inter, sans-serif',
          fontWeight: 600,
          fontSize: { xs: '2.05rem', sm: '2.35rem' },
          lineHeight: 1.1,
          color: '#1f2933',
          letterSpacing: '-0.02em',
        }}
      >
        My Clients
      </Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          width: { xs: '100%', sm: 'auto' },
        }}
      >
        <Button
          data-demo-id="clients-add"
          onClick={onAddClient}
          data-analytics-event="Create Client Clicked"
          data-analytics-id="clients_add_client"
          data-analytics-label="Add Client"
          data-analytics-section="clients_header"
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 600,
            fontSize: '0.95rem',
            textTransform: 'none',
            px: 3,
            py: 1.2,
            minWidth: { xs: 0, sm: 172 },
            flex: { xs: 1, sm: '0 0 auto' },
            borderRadius: '12px',
            bgcolor: '#23a8da',
            color: '#fff',
            boxShadow: '0 1px 2px rgba(16, 24, 40, 0.1)',
            '&:hover': {
              bgcolor: '#149bce',
              boxShadow: '0 2px 6px rgba(16, 24, 40, 0.15)',
            },
          }}
        >
          Add Client +
        </Button>
        <NotificationCenter buttonVariant="feature" />
      </Box>
    </Box>
  );
};
